import {
  enterprise_ads_features,
  enterprise_features,
  support_features,
} from 'data/Pricing/EntrpriseFeatures'
import React from 'react'

const EnterpriseAdsFeatures = () => {
  return (
    <div className=" w-full grid grid-cols-1 md:grid-cols-2 gap-16  bg-[#fbf4ff]  px-6 py-10  md:p-16 rounded-2xl items-center ">
      <div className=" flex flex-col gap-4 items-start order-last md:order-none ">
        <h3 className=" h3   !text-[30px]">Tradly for Enterprise</h3>
        <p className=" text-lightGray text-[18px] font-medium  leading-[27px] max-w-screen-md mr-0">
          Tailored for excellence in scalability, security, and support.
        </p>

        <div className=" w-full flex  flex-col md:flex-row items-center justify-start gap-3  mt-2 md:mt-4">
          <button className=" btn_blue_primary   !w-full  md:!w-auto !rounded-full">
            Contact Sales
          </button>
          <button className=" btn_white_primary   !w-full  md:!w-auto   !rounded-full">
            Learn More
          </button>
        </div>
      </div>
      <div className=" w-full">
        <div className=" grid  grid-cols-1 md:grid-cols-2    gap-x-8  gap-y-10 md:gap-y-12">
          {enterprise_ads_features.map((feature) => {
            return (
              <div className=" flex items-start justify-start   flex-col   ">
                <div className=" mb-6 flex items-center justify-center  text-periwinkle_blue h-10 w-10 bg-[#f3eaff]  ring-8 ring-white  rounded-full ">
                  {feature.icon}
                </div>
                <h4 className=" text-lg  font-bold text-dark_black mb-2">{feature.title} </h4>
                <p className="text-lightGray text-sm font-medium  leading-[21px]">
                  {feature.description}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default EnterpriseAdsFeatures
